 
  var tabsespddec = document.querySelectorAll('.tabs__btnpddec');
    var tabsContentdec = document.querySelectorAll('.tabs__bodypddec');
 


    if (tabsContentdec.length > 0 || tabs.length > 0) {

        function hideTabContent() {
            tabsContentdec.forEach(item => {
                item.classList.remove('active');
            });

            tabsespddec.forEach(item => {
                item.classList.remove('active');
            });
        }

        function showTabContent(i = 0) {
            tabsContentdec[i].classList.add('active');
            tabsespddec[i].classList.add('active');
        }

        hideTabContent();
        showTabContent();

        tabsespddec.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                hideTabContent();
                showTabContent(index);
            });
        });
    }

